// extracted by mini-css-extract-plugin
export var overlay = "loadingoverlay-module--overlay--fe03a";
export var overlaybackdrop = "loadingoverlay-module--overlaybackdrop--25662";